import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#222" }, [
      _createElementVNode("path", {
        "fill-opacity": ".24",
        d: "m12 18.1 2.325-2.325q.3-.3.725-.3t.725.3.3.725-.3.725L12.7 20.3q-.15.15-.325.213a1.15 1.15 0 0 1-.75 0 .85.85 0 0 1-.325-.213l-3.075-3.075q-.3-.3-.3-.725t.3-.725.725-.3.725.3z"
      }),
      _createElementVNode("path", { d: "M12 6 9.675 8.325q-.3.3-.725.3a.99.99 0 0 1-.725-.3q-.3-.3-.3-.725t.3-.725L11.3 3.8q.15-.15.325-.213T12 3.526q.2.001.375.063.175.06.325.212l3.075 3.075q.3.3.3.725t-.3.725-.725.3a.99.99 0 0 1-.725-.3z" })
    ], -1)
  ]))]))
}
export default { render: render }